import {gql} from '@apollo/client'

export const CREATE_TICKET = gql`
  mutation createTicket($ticketData: TicketCreateInput!) {
    createTicket(ticketData: $ticketData) {
      success
      errors {
        field
        message
      }
      ticket {
        id
      }
    }
  }
`

export const UPDATE_TICKET = gql`
  mutation updateTicket($id: ID!, $ticketData: TicketUpdateInput!) {
    updateTicket(id: $id, ticketData: $ticketData) {
      success
      errors {
        field
        message
      }
      ticket {
        id
      }
    }
  }
`

export const CHANGE_TICKET_STATUS = gql`
  mutation changeTicketStatus($id: ID!, $status: String!, $comment: String, $expectedUpdatedAt: DateTime) {
    changeTicketStatus(id: $id, status: $status, comment: $comment, expectedUpdatedAt: $expectedUpdatedAt) {
      success
      errors {
        field
        message
      }
      ticket {
        id
        status
        closedAt
      }
    }
  }
`

export const ARCHIVE_TICKET = gql`
  mutation archiveTicket($id: ID!, $isArchived: Boolean!, $expectedUpdatedAt: DateTime) {
    archiveTicket(id: $id, isArchived: $isArchived, expectedUpdatedAt: $expectedUpdatedAt) {
      success
      errors {
        field
        message
      }
      ticket {
        id
        isArchived
      }
    }
  }
`

export const ADD_TICKET_NOTE = gql`
  mutation addTicketNote($ticketId: ID!, $comment: String!) {
    addTicketNote(ticketId: $ticketId, comment: $comment) {
      success
      errors {
        field
        message
      }
      note {
        id
      }
    }
  }
`

export const DELETE_TICKET_ATTACHMENT = gql`
  mutation deleteTicketAttachment($id: ID!) {
    deleteTicketAttachment(id: $id) {
      success
      errors {
        field
        message
      }
    }
  }
`

export const DELETE_TICKET = gql`
  mutation deleteTicket($id: ID!) {
    deleteTicket(id: $id) {
      success
      errors {
        field
        message
      }
    }
  }
`

export const CREATE_TICKET_ATTACHMENT_STR = `
  mutation createTicketAttachment($ticketId: ID!, $file: Upload!, $originalName: String) {
    createTicketAttachment(ticketId: $ticketId, file: $file, originalName: $originalName) {
      success
      errors {
        field
        message
      }
      attachment {
        id
      }
    }
  }
`
